export const TIMELINE_PUSH_SELECTION = 'TIMELINE_PUSH_SELECTION';
export const TIMELINE_POP_SELECTION = 'TIMELINE_POP_SELECTION';

// init
export const ACTION_STARTUP_DATA = 'ACTION_STARTUP_DATA';

// global state management
export const ACTION_SELECT_DEVICE = 'ACTION_SELECT_DEVICE';
export const ACTION_SELECT_TIME_FILTER = 'ACTION_SELECT_TIME_FILTER';
export const ACTION_UPDATE_ROUTE_LIMIT = 'ACTION_UPDATE_ROUTE_LIMIT';
export const ACTION_UPDATE_DEVICES = 'ACTION_UPDATE_DEVICES';
export const ACTION_UPDATE_DEVICE = 'ACTION_UPDATE_DEVICE';
export const ACTION_UPDATE_ROUTE = 'ACTION_UPDATE_ROUTE';
export const ACTION_UPDATE_ROUTE_EVENTS = 'ACTION_UPDATE_ROUTE_EVENTS';
export const ACTION_UPDATE_ROUTE_LOCATION = 'ACTION_UPDATE_ROUTE_LOCATION';
export const ACTION_UPDATE_SHARED_DEVICE = 'ACTION_UPDATE_SHARED_DEVICE';
export const ACTION_UPDATE_DEVICE_ONLINE = 'ACTION_UPDATE_DEVICE_ONLINE';
export const ACTION_UPDATE_DEVICE_NETWORK = 'ACTION_UPDATE_DEVICE_NETWORK';
export const ACTION_UPDATE_DEVICE_RPC = 'ACTION_UPDATE_DEVICE_RPC';
export const ACTION_PRIME_NAV = 'ACTION_PRIME_NAV';
export const ACTION_STREAM_NAV = 'ACTION_STREAM_NAV';
export const ACTION_PRIME_SUBSCRIPTION = 'ACTION_PRIME_SUBSCRIPTION';
export const ACTION_PRIME_SUBSCRIBE_INFO = 'ACTION_PRIME_SUBSCRIBE_INFO';

// playback
export const ACTION_SEEK = 'ACTION_SEEK';
export const ACTION_PAUSE = 'ACTION_PAUSE';
export const ACTION_PLAY = 'ACTION_PLAY';
export const ACTION_LOOP = 'ACTION_LOOP';
export const ACTION_BUFFER_VIDEO = 'ACTION_BUFFER_VIDEO';
export const ACTION_RESET = 'ACTION_RESET';

// segments
export const ACTION_UPDATE_SEGMENT_RANGE = 'ACTION_UPDATE_SEGMENT_RANGE';
export const ACTION_ROUTES_METADATA = 'ACTION_ROUTES_METADATA';

// files
export const ACTION_FILES_URLS = 'ACTION_FILES_URLS';
export const ACTION_FILES_UPDATE = 'ACTION_FILES_UPDATE';
export const ACTION_FILES_UPLOADING = 'ACTION_FILES_UPLOADING';
export const ACTION_FILES_CANCELLED_UPLOADS = 'ACTION_FILES_CANCELLED_UPLOADS';

// analytics
export const ANALYTICS_EVENT = 'ANALYTICS_EVENT';
